import React from "react";

import {
  BrowserRouter,
  Routes,
  Route,
} from "react-router-dom";

import Navbar from "./components/Navbar";
import Footer from "./components/Footer";

import {
  LanguageProvider,
} from "./context/LanguageContext";

import Home from "./pages/Home";
import Cars from "./pages/Cars";
import CarDetails from "./pages/CarDetails";
import Booking from "./pages/Booking";
import Contact from "./pages/Contact";

import AdminLogin from "./pages/AdminLogin";
import AdminBookings from "./pages/AdminBookings";

function PublicLayout({
  children,
}) {
  return (
    <div className="public-site">
      <Navbar />

      <main className="public-main">
        {children}
      </main>

      <Footer />
    </div>
  );
}

function App() {
  return (
    <LanguageProvider>
      <BrowserRouter>
        <Routes>
          {/* HOME */}

          <Route
            path="/"
            element={
              <PublicLayout>
                <Home />
              </PublicLayout>
            }
          />

          {/* CARS */}

          <Route
            path="/cars"
            element={
              <PublicLayout>
                <Cars />
              </PublicLayout>
            }
          />

          {/* CAR DETAILS */}

          <Route
            path="/cars/:id"
            element={
              <PublicLayout>
                <CarDetails />
              </PublicLayout>
            }
          />

          {/* BOOKING */}

          <Route
            path="/booking"
            element={
              <PublicLayout>
                <Booking />
              </PublicLayout>
            }
          />

          {/* CONTACT */}

          <Route
            path="/contact"
            element={
              <PublicLayout>
                <Contact />
              </PublicLayout>
            }
          />

          {/* ADMIN LOGIN */}

          <Route
            path="/admin"
            element={
              <AdminLogin />
            }
          />

          {/* ADMIN BOOKINGS */}

          <Route
            path="/admin/bookings"
            element={
              <AdminBookings />
            }
          />
        </Routes>
      </BrowserRouter>
    </LanguageProvider>
  );
}

export default App;